import React from "react";

import { useTranslation } from "react-i18next";

import SwitchOnOff from "../../common/tools/SwitchOnOff";

import type { JSX } from "react";

import type {
  Project,
  StorefrontProjectParams,
} from "../../../api/ProjectAPI.types";

interface Props {
  project: Project;
  onChange: (
    key: "enable_gift_button",
    checked: StorefrontProjectParams["enable_gift_button"],
  ) => void;
}

export default function GiftsConfiguration({
  project,
  onChange,
}: Props): JSX.Element {
  const { t } = useTranslation("editor-platform");
  const enableGiftButton = project.storefront_project_params.enable_gift_button;

  const handleEnableGiftSwitch = (checked: boolean): void => {
    onChange("enable_gift_button", checked);
  };

  return (
    <div className="editor-form-section section-separator">
      <div className="editor-form-section-title">{t("giftsConfiguration")}</div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            checked={enableGiftButton ?? false}
            name="enable_gift_button"
            onChange={handleEnableGiftSwitch}
            size="sm"
          />
        </div>
        <div className="editor-form-label">{t("enableGiftButton")}</div>
      </div>
    </div>
  );
}
